import configData from '../../config.json'

const Summary = () => (
  <div>
    {configData.professional_summary}
  </div>
);

export default Summary;
